import React, { createRef, useRef } from 'react';
import PropTypes from 'prop-types';
import './Login.css';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}

class LoginDialog extends React.Component<Props> {
  static propTypes: {
    onClose: PropTypes.Requireable<(...args: any[]) => any>;
    isOpen: PropTypes.Requireable<boolean>;
    children: PropTypes.Requireable<PropTypes.ReactNodeLike>;
  };
  ref: React.MutableRefObject<any>;
  constructor(props: Props) {
    super(props);
    this.ref = createRef();
  }
  componentDidUpdate() {
    if (this.ref.current) {
      if (!this.ref.current.style.marginLeft) {
        this.ref.current.style.marginLeft = `-${this.ref.current.offsetWidth}px`;
        this.ref.current.style.maxWidth = `${this.ref.current.offsetWidth - 20}px`;
      }
    }
    document.addEventListener('mousedown', (e) => { this.handleClickOutside(e) });
  }

  handleClickOutside(event: any) {
    if (this.ref && this.ref.current) {
      if (!this.ref.current.contains(event.target)) {
        document.removeEventListener('mousedown', (e) => { this.handleClickOutside(e) });
        this.props.onClose();
      }
    }
  }

  public render() {
    if (!this.props.isOpen) {
      return null;
    }
    const ModalStyle = {
      cursor: 'default',
      backgroundColor: '#f6f6f6',
      padding: '20px',
    }

    return (
      <div ref={this.ref} style={ModalStyle} className="borders">
        {this.props.children}
      </div>
    )
  }
}
LoginDialog.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};
export default LoginDialog;